import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type TenantPricingPageFragment = { __typename?: 'TenantPricingPageDocument', content: string, id: string, tenantId: string, updatedAt: Types.TDateISO };

export type GetPricingPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPricingPageQuery = { __typename?: 'Query', pricingPage?: { __typename?: 'TenantPricingPageDocument', content: string, id: string, tenantId: string, updatedAt: Types.TDateISO } | null };

export const TenantPricingPageFragmentDoc = new TypedDocumentString(`
    fragment TenantPricingPage on TenantPricingPageDocument {
  content
  id
  tenantId
  updatedAt
}
    `, {"fragmentName":"TenantPricingPage"});
export const GetPricingPageDocument = new TypedDocumentString(`
    query GetPricingPage {
  pricingPage {
    ...TenantPricingPage
  }
}
    fragment TenantPricingPage on TenantPricingPageDocument {
  content
  id
  tenantId
  updatedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPricingPage: build.query<GetPricingPageQuery, GetPricingPageQueryVariables | void>({
      query: (variables) => ({ document: GetPricingPageDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPricingPageQuery, useLazyGetPricingPageQuery } = injectedRtkApi;
